/** Explanatory copy only. The signed determination remains the authority. */
export function receiptFailureGuidance(status: string, reasonCodes: readonly string[]) {
  if (status.toUpperCase() === "PASS") return null;
  const codes = reasonCodes.join(" ").toLowerCase();
  if (/not-independently-observed|oracle:git-tree:unresolvable|no-claim/.test(codes)) {
    return {
      explanation: "The verifier could not independently confirm which files changed.",
      action: "Ask the verification operator to collect the changed-file evidence from the recorded worker attempt, then retry verification against the accepted contract.",
    };
  }
  if (/resource-bounds|outside.*bounds|out-of-bounds/.test(codes)) {
    return {
      explanation: "The recorded changes could not be confirmed within the agreed file scope.",
      action: "Inspect the changed-file evidence. Repair changes outside the allowed paths, or obtain a new agreement if the task needs a broader scope, before submitting a new attempt.",
    };
  }
  if (/exit-code|exit-nonzero/.test(codes)) {
    return {
      explanation: "The recorded command result did not meet the accepted check.",
      action: "Open the command log below, fix the reported problem, and have the worker submit a repair linked to the failed attempt. The verifier must check the new output.",
    };
  }
  if (/artifact.*(missing|absent|not-present)|evidence.*(missing|gap)|missing.*(artifact|evidence)/.test(codes)) {
    return {
      explanation: "Required evidence was missing or could not be admitted for this check.",
      action: "Inspect the required artifact and its recorded attempt. Have the worker or verification operator provide the missing evidence, then retry verification.",
    };
  }
  if (/replay/.test(codes)) {
    return {
      explanation: "The independent replay could not establish the required result.",
      action: "Inspect the replay details below. Ask the verification operator to resolve the reported replay problem and rerun the accepted check for this attempt.",
    };
  }
  return {
    explanation: status.toUpperCase() === "FAIL"
      ? "This check did not satisfy the accepted requirement."
      : "This check has no confirmed passing result.",
    action: "Inspect the evidence and technical details below, then open the Work to check for a newer result. If unresolved, share this receipt with the worker or verification operator before retrying.",
  };
}
